import { render } from "./ClientSummary.vue?vue&type=template&id=4fbc2d6c&scoped=true"
import script from "./ClientSummary.vue?vue&type=script&lang=js"
export * from "./ClientSummary.vue?vue&type=script&lang=js"

import "./ClientSummary.vue?vue&type=style&index=0&id=4fbc2d6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fbc2d6c"]])

export default __exports__